import React from 'react';
import { X, Sparkles, Target, Users, Trophy } from 'lucide-react';

const WelcomeModal = ({ user, onClose, onStartTour }) => {
  const isCoach = user?.role === 'coach';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.6)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '24px'
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        borderRadius: '24px',
        padding: '48px',
        maxWidth: '600px',
        width: '100%',
        border: '1px solid rgba(37, 99, 235, 0.2)',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        position: 'relative'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '24px',
            right: '24px',
            padding: '8px',
            background: '#f1f5f9',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            color: '#64748b',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#fee2e2';
            e.target.style.borderColor = '#fecaca';
            e.target.style.color = '#dc2626';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = '#f1f5f9';
            e.target.style.borderColor = '#e2e8f0';
            e.target.style.color = '#64748b';
          }}
        >
          <X size={20} />
        </button>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{
            width: '80px',
            height: '80px',
            background: 'linear-gradient(135deg, #2563eb, #3b82f6)',
            borderRadius: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            boxShadow: '0 10px 25px rgba(37, 99, 235, 0.2)'
          }}>
            <div style={{ color: 'white', fontSize: '32px' }}>⏱</div>
          </div>
          
          <h1 style={{
            fontSize: '32px',
            fontWeight: '800',
            color: '#1e293b',
            margin: '0 0 8px 0',
            fontFamily: '"Inter", sans-serif',
            letterSpacing: '-0.02em'
          }}>
            Welcome to <span style={{ color: '#2563eb' }}>Coach's Log</span>!
          </h1>
          
          <p style={{
            color: '#64748b',
            fontSize: '18px',
            fontWeight: '500',
            margin: 0,
            letterSpacing: '0.025em'
          }}>
            {isCoach ? 'Professional Training Management' : 'Your Training Journey Starts Here'}
          </p>
        </div>

        {/* Features */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: isCoach ? 'repeat(3, 1fr)' : '1fr',
          gap: '24px',
          marginBottom: '32px'
        }}>
          {isCoach ? (
            <>
              <div style={{
                padding: '24px',
                background: 'white',
                borderRadius: '16px',
                border: '1px solid #e2e8f0',
                textAlign: 'center',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#2563eb';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(37, 99, 235, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#e2e8f0';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >
                <Target style={{ color: '#2563eb', marginBottom: '12px' }} size={32} />
                <h3 style={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '8px'
                }}>
                  Create Templates
                </h3>
                <p style={{
                  fontSize: '14px',
                  color: '#64748b',
                  margin: 0,
                  lineHeight: '1.5'
                }}>
                  Build reusable workout templates for different intensities
                </p>
              </div>

              <div style={{
                padding: '24px',
                background: 'white',
                borderRadius: '16px',
                border: '1px solid #e2e8f0',
                textAlign: 'center',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#2563eb';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(37, 99, 235, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#e2e8f0';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >
                <Users style={{ color: '#2563eb', marginBottom: '12px' }} size={32} />
                <h3 style={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '8px'
                }}>
                  Manage Athletes
                </h3>
                <p style={{
                  fontSize: '14px',
                  color: '#64748b',
                  margin: 0,
                  lineHeight: '1.5'
                }}>
                  Assign workouts and track athlete progress in real-time
                </p>
              </div>

              <div style={{
                padding: '24px',
                background: 'white',
                borderRadius: '16px',
                border: '1px solid #e2e8f0',
                textAlign: 'center',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#2563eb';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(37, 99, 235, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#e2e8f0';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >
                <Trophy style={{ color: '#2563eb', marginBottom: '12px' }} size={32} />
                <h3 style={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '8px'
                }}>
                  Track Progress
                </h3>
                <p style={{
                  fontSize: '14px',
                  color: '#64748b',
                  margin: 0,
                  lineHeight: '1.5'
                }}>
                  Monitor feedback, personal bests, and training patterns
                </p>
              </div>
            </>
          ) : (
            <div style={{
              padding: '32px',
              background: 'white',
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              textAlign: 'center'
            }}>
              <Sparkles style={{ color: '#2563eb', marginBottom: '16px' }} size={48} />
              <h3 style={{
                fontSize: '20px',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '12px'
              }}>
                Your Training Dashboard
              </h3>
              <p style={{
                fontSize: '16px',
                color: '#64748b',
                margin: 0,
                lineHeight: '1.6'
              }}>
                View your weekly schedule, complete workouts, track personal bests, and provide feedback to your coach.
              </p>
            </div>
          )}
        </div>

        {/* Getting Started */}
        <div style={{
          background: 'rgba(37, 99, 235, 0.05)',
          borderRadius: '16px',
          padding: '24px',
          border: '1px solid rgba(37, 99, 235, 0.1)',
          marginBottom: '32px'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '700',
            color: '#1e293b',
            marginBottom: '12px'
          }}>
            🚀 Getting Started
          </h3>
          <p style={{
            fontSize: '14px',
            color: '#64748b',
            margin: '0 0 16px 0',
            lineHeight: '1.6'
          }}>
            {isCoach 
              ? "Ready to create your first workout template and start managing athletes? Let's get you oriented with a quick tour."
              : "Your coach will assign workouts to your schedule. You can complete them, mark personal bests, and provide feedback."
            }
          </p>
          
          {isCoach && user?.coach_code && (
            <div style={{
              background: 'white',
              padding: '16px',
              borderRadius: '12px',
              border: '1px solid #e2e8f0',
              marginTop: '16px'
            }}>
              <div style={{
                fontSize: '12px',
                fontWeight: '700',
                color: '#2563eb',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                marginBottom: '4px'
              }}>
                Your Coach Code:
              </div>
              <div style={{
                fontSize: '20px',
                fontWeight: '800',
                color: '#1e293b',
                fontFamily: '"JetBrains Mono", monospace',
                letterSpacing: '0.1em'
              }}>
                {user.coach_code}
              </div>
              <div style={{
                fontSize: '12px',
                color: '#64748b',
                marginTop: '4px',
                fontWeight: '500'
              }}>
                Share this with your athletes to get started
              </div>
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={onStartTour}
            style={{
              padding: '16px 32px',
              background: 'linear-gradient(135deg, #2563eb, #3b82f6)',
              border: 'none',
              borderRadius: '12px',
              color: 'white',
              fontWeight: '600',
              fontSize: '16px',
              cursor: 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              transition: 'all 0.2s',
              boxShadow: '0 4px 14px rgba(37, 99, 235, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 25px rgba(37, 99, 235, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 14px rgba(37, 99, 235, 0.3)';
            }}
          >
            🎓 Take Quick Tour
          </button>
          
          <button
            onClick={onClose}
            style={{
              padding: '16px 32px',
              background: 'white',
              border: '1px solid #e2e8f0',
              borderRadius: '12px',
              color: '#64748b',
              fontWeight: '600',
              fontSize: '16px',
              cursor: 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#f8fafc';
              e.target.style.borderColor = '#cbd5e1';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'white';
              e.target.style.borderColor = '#e2e8f0';
            }}
          >
            Skip for Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;